import React from 'react';

import { CameraMode, PhotoSeriesStoreState } from '../root';

type SetPhotoSeriesStoreState = React.Dispatch<React.SetStateAction<PhotoSeriesStoreState>>;

export const setFileInput = (
  fileInput: HTMLInputElement | null,
  setPhotoSeriesStoreState: SetPhotoSeriesStoreState
) => {
  setPhotoSeriesStoreState((prevPhotoSeriesStoreState) => ({
    ...prevPhotoSeriesStoreState,
    camera: {
      ...prevPhotoSeriesStoreState.camera,
      fileInput,
    },
  }));
};

export const dispatchCameraMode = (
  mode: CameraMode,
  setPhotoSeriesStoreState: SetPhotoSeriesStoreState
) => {
  setPhotoSeriesStoreState((prevPhotoSeriesStoreState) => {
    if (prevPhotoSeriesStoreState.camera.mode === mode) return prevPhotoSeriesStoreState;

    return {
      ...prevPhotoSeriesStoreState,
      camera: {
        ...prevPhotoSeriesStoreState.camera,
        mode,
      },
    };
  });
};
